var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberPri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33115 16.0996C7.99423 15.9143 7.5869 15.9176 7.25865 16.1137L3.19832 18.497L4.78865 12.3112C5.73657 12.8528 6.83182 13.167 7.99965 13.167C9.16748 13.167 10.2627 12.8528 11.2117 12.3112L12.8248 18.5858L8.33115 16.0996ZM7.99965 2.33366C10.3895 2.33366 12.333 4.27716 12.333 6.66699C12.333 9.05683 10.3895 11.0003 7.99965 11.0003C5.60982 11.0003 3.66632 9.05683 3.66632 6.66699C3.66632 4.27716 5.60982 2.33366 7.99965 2.33366ZM15.5494 20.4806L13.048 10.7533C13.9537 9.63533 14.4997 8.21508 14.4997 6.66699C14.4997 3.08224 11.5844 0.166992 7.99965 0.166992C4.41598 0.166992 1.49965 3.08224 1.49965 6.66699C1.49965 8.21508 2.04565 9.63533 2.95132 10.7533L0.450984 20.4806C0.341568 20.9052 0.498651 21.3527 0.848568 21.6159C1.1974 21.8792 1.6719 21.903 2.04782 21.6842L7.82198 18.2944L13.9753 21.6982C14.1389 21.7892 14.3198 21.8337 14.4997 21.8337C14.7347 21.8337 14.9687 21.7578 15.1637 21.6072C15.505 21.3429 15.6577 20.8998 15.5494 20.4806Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPri);
export default __webpack_public_path__ + "static/media/memberPri.0e81843091e6d7835174d787d43aca36.svg";
export { ForwardRef as ReactComponent };